"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuIcon = exports.USER_TYPE = exports.PLATFORM_ACCOUNT_QUERY_GIST_TYPE = exports.PICKER_OPTIONS = exports.PAGE_SIZE_CONFIG = exports.LOGIN_TYPE = exports.IMPORT_DATA_FIELDS_MAP = exports.DEFAULT_DATE_REGION = exports.DEFAULT_DATE = exports.DEFAULT_30_DATE_REGION = exports.ACCOUNT_TYPE = void 0;
var _time = require("@/utils/time");
// 定义常量

// 默认时间区间
var DEFAULT_DATE_REGION = {
  'start_date': (0, _time.parseTime)(new Date().getTime() - 3600 * 1000 * 24 * 7),
  'end_date': (0, _time.parseTime)(new Date().getTime())
};
exports.DEFAULT_DATE_REGION = DEFAULT_DATE_REGION;
var DEFAULT_30_DATE_REGION = {
  'start_date': (0, _time.parseTime)(new Date().getTime() - 3600 * 1000 * 24 * 30),
  'end_date': (0, _time.parseTime)(new Date().getTime())
};
exports.DEFAULT_30_DATE_REGION = DEFAULT_30_DATE_REGION;
var DEFAULT_DATE = {
  'start_date': (0, _time.parseTime)(new Date().getTime()),
  'end_date': (0, _time.parseTime)(new Date().getTime())
};

// 默认分页
exports.DEFAULT_DATE = DEFAULT_DATE;
var PAGE_SIZE_CONFIG = [20, 50, 100];

// 默认日期选择配置
exports.PAGE_SIZE_CONFIG = PAGE_SIZE_CONFIG;
var PICKER_OPTIONS = {
  shortcuts: [{
    text: '今天',
    onClick: function onClick(picker) {
      var end = (0, _time.parseTime)(new Date().getTime());
      var start = end;
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '昨天',
    onClick: function onClick(picker) {
      var end = (0, _time.parseTime)(new Date().getTime() - 3600 * 1000 * 24);
      var start = end;
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一周',
    onClick: function onClick(picker) {
      var end = (0, _time.parseTime)(new Date().getTime());
      var start = (0, _time.parseTime)(new Date().getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一个月',
    onClick: function onClick(picker) {
      var end = (0, _time.parseTime)(new Date().getTime());
      var start = (0, _time.parseTime)(new Date().getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    }
  }]
};

/**
 * 用户数据查询依据类型
 * @type {Object}
 */
exports.PICKER_OPTIONS = PICKER_OPTIONS;
var PLATFORM_ACCOUNT_QUERY_GIST_TYPE = {
  0: '平台账号',
  1: '手机号'
  // 2: '微信UnionId',
  // 3: 'QQUnionId'
};

/**
 * 用户类型
 * @type {Object}
 */
exports.PLATFORM_ACCOUNT_QUERY_GIST_TYPE = PLATFORM_ACCOUNT_QUERY_GIST_TYPE;
var USER_TYPE = {
  1: {
    label: '普通用户',
    tag_type: 'primary'
  },
  2: {
    label: 'GM',
    tag_type: 'success'
  },
  3: {
    label: '超级管理员',
    tag_type: 'danger'
  }
};

/**
 * 账号类型
 * @type {Object}
 */
exports.USER_TYPE = USER_TYPE;
var ACCOUNT_TYPE = {
  0: {
    label: '普通账号',
    tag_type: 'primary'
  },
  1: {
    label: '临时账号',
    tag_type: 'info'
  }
};

/**
 * 登录类型
 * @type {Object}
 */
exports.ACCOUNT_TYPE = ACCOUNT_TYPE;
var LOGIN_TYPE = {
  1: {
    label: '手机短信登录',
    tag_type: '',
    tag_color: '#221F20'
  },
  2: {
    label: '微信登陆',
    tag_type: '',
    tag_color: '#22AC38'
  },
  3: {
    label: 'QQ登陆',
    tag_type: '',
    tag_color: '#1476FF'
  },
  4: {
    label: '平台账号密码登陆',
    tag_type: '',
    tag_color: '#FF7A2D'
  },
  5: {
    label: '手机密码登陆',
    tag_type: '',
    tag_color: '#1DC267'
  },
  6: {
    label: '临时账号登陆',
    tag_type: '',
    tag_color: '#1CB88E'
  },
  7: {
    label: '设备登陆',
    tag_type: '',
    tag_color: '#FF2525'
  }
};
exports.LOGIN_TYPE = LOGIN_TYPE;
var IMPORT_DATA_FIELDS_MAP = {
  'id': 'id',
  'product_id': 'product_id',
  'card_id': 'card_id',
  'card_name': 'card_name',
  'num': 'num',
  'price': 'price'
};

// 菜单icon数组
exports.IMPORT_DATA_FIELDS_MAP = IMPORT_DATA_FIELDS_MAP;
var menuIcon = ['空', 'dashboard', 'list', 'prop', 'user', 'search', 'size', 'tip', 'totals', 'visits', 'operateLog', 'loginLog', 'log', 'system', 'app', 'menu', 'role', '404', 'abnormal', 'activate', 'actives', 'ad', 'ad_flow', 'anti_addiction', 'api', 'bug', 'channel', 'data', 'del', 'detail', 'devices', 'drag', 'edit', 'event', 'exit-fullscreen', 'eye-open', 'eye', 'filter', 'flow', 'fullscreen', 'game', 'invest', 'link', 'monitor', 'notice', 'params', 'password', 'performance', 'project', 'promotion', 'purchase', 'real_name', 'registers', 'retention', 'scene', 'servers', 'share', 'statistics', 'table', 'tag', '充值报表', '充值渗透', '充值留存', '分端充值留存', '分端数据', '分端用户LTV', '广告管理', '广告组', '广告账号', '扩展数据', '按小时汇总', '按日期汇总', '推广活动设置', '推广渠道', '数据分析', '日报', '每日roi', '每月roi', '用户LTV', '用户留存', '转端数据', '首充留存'];
exports.menuIcon = menuIcon;